import Joi from 'joi';

const maxLength = 50;
function doesNotExceedMaxLength(maxLength, errorPropertyName) {
  return Joi.string().max(maxLength).message(`${errorPropertyName} allows up to ${maxLength} characters.`);
}

const cannotBeNumbersAndUnderscoresOnly = Joi.string()
  .pattern(/^[0-9_]+$/, { invert: true })
  .message('A letter must be included.');

const numbersStringsUnderscoresOnly = Joi.string()
  .pattern(/^[a-zA-Z0-9_]+$/)
  .message('Only numbers, letters, or underscores may be used.');

const CustomAttributesSchema = Joi.object({
  label: doesNotExceedMaxLength(maxLength, 'Display name'),
  key: doesNotExceedMaxLength(maxLength, 'Key')
    .concat(cannotBeNumbersAndUnderscoresOnly)
    .concat(numbersStringsUnderscoresOnly),
});

export function getCustomAttributesSchema(): Joi.ObjectSchema {
  return CustomAttributesSchema;
}
